export default __webpack_public_path__ + "static/media/LOBO-ESTEPARIO.ae974e06.png";